import { render } from "./queueComponent.vue?vue&type=template&id=1ab87e95&scoped=true"
import script from "./queueComponent.vue?vue&type=script&lang=js"
export * from "./queueComponent.vue?vue&type=script&lang=js"

import "./queueComponent.vue?vue&type=style&index=0&id=1ab87e95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab87e95"]])

export default __exports__